<div class="settings-page">
  <main class="settings-grid">
    @if (state.userHasMinType(3)) {
    <ion-card class="panel company-panel" aria-labelledby="company-heading">
      <ion-card-header class="section-heading">
        <span class="section-icon company-icon">
          <ion-icon name="business-outline" aria-hidden="true"></ion-icon>
        </span>
        <div>
          <ion-card-title id="company-heading">{{
            "company.title" | translate
          }}</ion-card-title>
        </div>
      </ion-card-header>
      <ion-card-content class="panel-content">
        <div class="company-management">
          <ion-button (click)="createCompany()">
            <ion-icon name="add-outline" slot="start" class="white"></ion-icon>
            {{ "company.create" | translate }}
          </ion-button>
          <lib-company-picker
            [items]="state.companies$ | async"
            [preselectedItem]="state.selectedCompany$ | async"
            [showAllEntry]="false"
            (selectedItemChanged)="itemChanged($event)"
          ></lib-company-picker>
        </div>
      </ion-card-content>
    </ion-card>
    }
    <ion-card class="panel account-panel" aria-labelledby="account-heading">
      <ion-card-header class="section-heading">
        <span class="section-icon account-icon">
          <ion-icon name="person-outline" aria-hidden="true"></ion-icon>
        </span>
        <div>
          <ion-card-title id="account-heading">{{
            "settings.account" | translate
          }}</ion-card-title>
        </div>
      </ion-card-header>
      <ion-card-content class="panel-content">
        <div class="logo-preview">
          @if (companyLogoUrl) {
          <img
            [src]="companyLogoUrl"
            [alt]="'settings.companyLogo' | translate"
          />
          } @else {
          <ion-icon name="image-outline" aria-hidden="true"></ion-icon>
          }
        </div>
        <dl class="details-list">
          <div class="detail-row">
            <dt>{{ "common.name" | translate }}</dt>
            <dd>{{ state.displayName }}</dd>
          </div>
          <div class="detail-row">
            <dt>{{ "common.username" | translate }}</dt>
            <dd>{{ state.userName }}</dd>
          </div>
          <div class="detail-row">
            <dt>{{ "settings.userType" | translate }}</dt>
            <dd>{{ getUserType() }}</dd>
          </div>
          <div class="detail-row">
            <dt>{{ "company.title" | translate }}</dt>
            <dd>{{ (state.selectedCompany$ | async)?.name }}</dd>
          </div>
          <div class="detail-row" *ngIf="state.userHasMinType(1)">
            <dt>{{ "settings.storageUsed" | translate }}</dt>
            <dd>{{ nodeItemsStorageInGb }} GB</dd>
          </div>
        </dl>
      </ion-card-content>
    </ion-card>

    <ion-card class="panel signature-panel" aria-labelledby="signature-heading">
      <ion-card-header class="section-heading">
        <span class="section-icon signature-icon">
          <ion-icon name="create-outline" aria-hidden="true"></ion-icon>
        </span>
        <div>
          <ion-card-title id="signature-heading">{{
            "settings.signature" | translate
          }}</ion-card-title>
        </div>
      </ion-card-header>
      <ion-card-content class="panel-content">
        @if (state.currentSignature != null) {
        <lib-signature
          (saveSignature)="saveSignature($event)"
          [currentSignature]="state.currentSignature"
        ></lib-signature>
        }
      </ion-card-content>
    </ion-card>
    <ion-card class="panel help-panel" aria-labelledby="help-heading">
      <ion-card-header class="section-heading">
        <span class="section-icon help-icon">
          <ion-icon name="help-circle-outline" aria-hidden="true"></ion-icon>
        </span>
        <div>
          <ion-card-title id="help-heading">{{
            "settings.helpUpdates" | translate
          }}</ion-card-title>
        </div>
      </ion-card-header>
      <ion-card-content class="panel-content">
        <div class="help-actions">
          <ion-button fill="outline" (click)="showHelpModal()">
            <ion-icon name="help-circle-outline" slot="start"></ion-icon>
            {{ "settings.showHelp" | translate }}
          </ion-button>

          <ion-button
            class="version-button"
            fill="clear"
            (click)="tools.openAppStore()"
          >
            {{ "settings.version" | translate : { version: state.version } }}
          </ion-button>
        </div>
        @if (state.updateAvailable) {
        <ion-button (click)="tools.openAppStore()" style="width: 100%">
          <ion-icon
            name="arrow-up-circle-outline"
            class="white"
            slot="start"
          ></ion-icon>
          {{ "settings.updateApp" | translate }}
        </ion-button>
        }
        <br />
        <ion-select
          fill="outline"
          mode="md"
          interface="popover"
          [value]="currentLanguage"
          (ionChange)="changeLanguage($event.detail.value)"
          [attr.aria-label]="'settings.language' | translate"
        >
          <ion-select-option value="de">{{
            "languages.de" | translate
          }}</ion-select-option>
          <ion-select-option value="en">{{
            "languages.en" | translate
          }}</ion-select-option>
        </ion-select>
        @if(state.isMobile){
        <br />
        <ion-button (click)="tools.openWebApp()" style="width: 100%">
          <ion-icon name="globe-outline" class="white" slot="start"></ion-icon>
          {{ "settings.openWebApp" | translate }}
        </ion-button>
        }
      </ion-card-content>
    </ion-card>
  </main>
</div>
